import {Language} from "../components/Firebase/index";

export const languages: Language[] = [
    new Language("cs", "🇨🇿 Česky"),
    new Language("en", "🇬🇧 English")
]